define.alias("shared/components/shared/post/secondary/hashtag-suggestions/tabs", "calendar/components/shared/post/secondary/hashtag-suggestions/tabs");